import {
  AlertTriangle,
  Calendar,
  CalendarClock,
  Clock,
  type LucideIcon,
} from "lucide-react";
import type {
  TaskBucket,
  TaskPriorityApi,
  TaskReminderOffset,
  TaskScope,
  TaskView,
} from "@/api/types";

export interface BucketDef {
  k: TaskBucket;
  label: string;
  tone: "destructive" | "amber" | "primary" | "muted";
  icon: LucideIcon;
}

export const BUCKETS: BucketDef[] = [
  { k: "overdue", label: "Прострочені", tone: "destructive", icon: AlertTriangle },
  { k: "today", label: "Сьогодні", tone: "amber", icon: CalendarClock },
  { k: "week", label: "Цей тиждень", tone: "primary", icon: Calendar },
  { k: "later", label: "Пізніше", tone: "muted", icon: Clock },
];

export const VIEWS: Array<{ k: TaskView; label: string }> = [
  { k: "all", label: "Усі" },
  { k: "overdue", label: "Прострочені" },
  { k: "today", label: "Сьогодні" },
  { k: "meeting", label: "Зустрічі / Follow-up" },
  { k: "general", label: "Загальні" },
];

export const SCOPE_LABELS: Record<TaskScope, string> = {
  my: "Мої",
  team: "Команда",
  all: "Усі",
};

export const PRIORITY_LABELS: Record<TaskPriorityApi, string> = {
  high: "Високий",
  medium: "Середній",
  low: "Низький",
};

export const REMINDER_OPTIONS: Array<{ k: TaskReminderOffset; label: string }> = [
  { k: "due_day", label: "У день дедлайну" },
  { k: "1d_before", label: "За 1 день" },
  { k: "none", label: "Без" },
];

/** Compose a YYYY-MM-DD value N days from today (local). */
export function quickDatePlus(daysFromNow: number): string {
  const d = new Date();
  d.setDate(d.getDate() + daysFromNow);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}
